export class ExportRequest {
    RequestIDs: number[];
    EmployeeID: number;
}

export default ExportRequest